

















import Vue from 'vue'
import {areaTelNameList, getTelNumber} from '../config';

export default Vue.extend({
  name: 'Contact',
  data() {
    return {
      areaTelName: null,
    }
  },
  mounted: function() {
    areaTelNameList.forEach((item, i) => {
      if (location.href.indexOf(item) !== -1) {
        this.areaTelName = item;
      }
    });
  },
  computed: {
  },
  methods: {
  }
})
